import {
	TravelItinerarySummaryJSON,
	TravelItinerarySummary,
} from './travel-itinerary-summary.model';
import { BaseResponse } from './base-response.model';

export class TravelQueueResponse extends BaseResponse {
	constructor(
		public message: string,
		public queue: TravelItinerarySummaryJSON[]
	) {
		super(message);
	}
}

export class TravelQueuesResponse extends BaseResponse {
	constructor(
		public message: string,
		public administrative: TravelQueueJSON,
		public travelAdmin: TravelQueueJSON,
		public manager: TravelQueueJSON,
		public myTravel: TravelQueueJSON
	) {
		super(message);
	}
}

export interface TravelQueueJSON {
	queue: TravelItinerarySummaryJSON[];
	count: number;
	page: number;
	limit: number;
}

export class TravelQueue {
	constructor(
		public queue: TravelItinerarySummary[],
		public count: number,
		public page: number,
		public limit: number
	) {}

	static fromJSON(json: TravelQueueJSON): TravelQueue {
		const queue = Object.create(TravelQueue.prototype);
		return Object.assign(queue, json, {
			queue: json.queue.map((summary) =>
				TravelItinerarySummary.fromJSON(summary)
			),
		});
	}
}
